<transaction-list-detail-template
  [transaction]="transaction"
  (closeEmitter)="closeEmitter?.emit($event)"
  [getFrom]="getFromWalletName()"
  [getTo]="getToWalletName()">
  <ng-container fromWallet>
    <span [ngClass]="{ 'color-text button-weight': isCreditCard() }">{{ getFromWalletName() }}</span>
    @if (isCardDeposit()) {
      <div class="mt-5">{{ "card_number_tx_item" | translate }}</div>
      <div class="color-text button-weight">{{ transaction?.getCCardDigits() }}</div>
    }
  </ng-container>
  <ng-container toWallet>
    <span [ngClass]="{ 'color-text button-weight': isBankTransfer() }">{{ getToWalletName() }}</span>
    @if (showWalletNameLink()) {
      <span>
        <a [href]="tradable?.urlCheckAddress().replace('%s', transaction?.getRecipient())" [target]="'_blank'">
          {{ transaction?.getRecipient() }}
        </a>
      </span>
    }
    @if (isCardWithdrawal()) {
      @if (getCardHolderName(); as cardHolderName) {
        <div class="mt-5">{{ "name_on_card" | translate }}</div>
        <div class="color-text button-weight">{{ cardHolderName }}</div>
      }
      @if (getCardMask(); as cardNumberMask) {
        <div class="mt-5">{{ "card_number_tx_item" | translate }}</div>
        <div class="color-text button-weight">{{ cardNumberMask }}</div>
      }
    }
    @if (showBankDetails()) {
      <div class="mt-5">{{ "iban_tx_item" | translate }}</div>
      <div class="color-text button-weight">{{ getPayAccountIban() }}</div>
      <div class="mt-5">{{ "bic_tx_item" | translate }}</div>
      <div class="color-text button-weight">{{ getPayAccountBic() }}</div>
    }
  </ng-container>
  @if (isDividend()) {
    <ng-container fromAsset>{{ getDividendAssetName() }}</ng-container>
  }
  <ng-container amountExchanged>
    @if (!isExternalTx()) {
      {{ getCryptoAmount() | tradable_precision_symbol: { id: getCurrencyId(), ignorePrecision: true } }}
    }
    @if (isExternalTx()) {
      {{
      transaction?.getAmount()
      | fiat_precision_symbol: { id: fiat?.getId(), symbol: true, currencies: [fiat] }
      }}
    }
  </ng-container>
  <ng-container cryptoPrice>
    &#64; 1 {{ tradable?.getSymbol() }} =
    {{
    transaction?.getTrade()?.getPrice()
    | fiat_precision_symbol
    : {
    id: txFiat?.getId(),
    symbol: true,
    currencies: [txFiat, transaction?.getTrade()?.getCurrencyId() | tradable]
  }
  }}
</ng-container>
<ng-container relatedTx>
  @if (containsSwap()) {
    <div>
      <a (click)="openSwapDetails()">{{ "swap_show_more_tx_item" | translate }}</a>
    </div>
  }
  @if (containsDebitCardRelatedTx()) {
    <div>
      <a (click)="openDebitCardDetails()">{{ "debit_card_tx_related" | translate }}</a>
    </div>
  }
</ng-container>
<ng-container sendFee>
  <div>{{ "fee" | translate }}</div>
  <div class="color-text button-weight">
    {{ transaction?.getFee() | fiat_precision_symbol: { id: fiat?.getId(), symbol: true, currencies: [fiat] } }}
  </div>
</ng-container>

<ng-container vsnUsed>
  {{ getVsnFeeAmount() }} VSN
</ng-container>

<ng-container vsnPrice>
  1 VSN = {{ getVsnFeeRate() | fiat_precision_symbol: { id: fiat?.getId(), symbol: true, currencies: [fiat] } }}
</ng-container>

<ng-container amountTotal>
  <ng-container>
    {{
    transaction?.getAmountWithoutFee()
    | fiat_precision_symbol: { id: fiat?.getId(), symbol: true, currencies: [fiat] }
    | value_change_prefix: { isProfit: !transaction?.isOutgoing() }
    }}
  </ng-container>
</ng-container>

<!-- Fiat Bitpanda Payments specific logo -->
@if (isFiatSend()) {
  <ng-container transactionLogo>
    <img
      class="payment-ref-logo mt-15"
      [src]="logoUrl(getPayoutProvider())"
      [alt]="'bitpanda_payments_logo_alt_text' | translate" />
  </ng-container>
}
</transaction-list-detail-template>